export default {
	'trustly-total-cash': 'kokonaissaldo',
	'terms-and-conditions-privacy-policy': 'Vakuutan, että olen vähintään 18-vuotias ja hyväksyn <a href="/fi-fi/?page=terms" target="_blank" class="ui-link">Säännöt ja ehdot</a> sekä <a href="/fi-fi/?page=privacy" target="_blank" class="ui-link">Tietosuojalausunnon</a>.'
}